(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evione-article-related"] && !Shopify.designMode) return;
  try {
    
  class EvioneArticleCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-arel-track]');
      this.prevBtn = this.querySelector('[data-arel-prev]');
      this.nextBtn = this.querySelector('[data-arel-next]');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this.scrollByCards(-1));
      this.nextBtn.addEventListener('click', () => this.scrollByCards(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
      this.updateButtons();
    }

    step() {
      const first = this.track.querySelector('.evione-arel__item');
      if (!first) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    scrollByCards(dir) {
      this.track.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    updateButtons() {
      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      this.prevBtn.disabled = this.track.scrollLeft <= 0;
      this.nextBtn.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('evione-article-carousel')) {
    customElements.define('evione-article-carousel', EvioneArticleCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evione-knowledge"] && !Shopify.designMode) return;
  try {
    
  class EvioneKnTags extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-kn-track]');
      this.bar = this.querySelector('[data-kn-bar]');
      this.thumb = this.querySelector('[data-kn-thumb]');
      if (!this.track || !this.bar || !this.thumb) return;
      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    update() {
      const overflow = this.track.scrollWidth - this.track.clientWidth;
      if (overflow <= 1) { this.bar.style.display = 'none'; return; }
      this.bar.style.display = 'block';
      const pct = Math.max(14, (this.track.clientWidth / this.track.scrollWidth) * 100);
      const progress = this.track.scrollLeft / overflow;
      this.thumb.style.width = pct + '%';
      this.thumb.style.insetInlineStart = (progress * (100 - pct)) + '%';
    }
  }
  if (!customElements.get('evione-kn-tags')) {
    customElements.define('evione-kn-tags', EvioneKnTags);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evione-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var RATE = 0.2; // slow motion
    function slow(v) { try { v.playbackRate = RATE; } catch (e) {} }
    document.querySelectorAll('video.evione-story__hero-mediael').forEach(function (v) {
      slow(v);
      v.addEventListener('loadedmetadata', function () { slow(v); });
      v.addEventListener('play', function () { slow(v); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
